import React, { type HTMLProps } from 'react'

const GlyphSmallCancel: React.FC<HTMLProps<SVGSVGElement>> = props => (
  <svg viewBox='0 0 100 100' {...props}>
    <path d='M63.79 63.2l-3.88 3.88-9.71-9.7-9.7 9.7-3.88-3.88 9.7-9.71-9.7-9.7 3.88-3.88 9.7 9.7 9.71-9.7 3.88 3.88-9.7 9.7 9.7 9.71z' />
  </svg>
)

export default GlyphSmallCancel
